import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextAlignCenter = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="lucide lucide-align-justify"
    viewBox="0 0 24 24"
    aria-label="IconTextAlignCenter"
    stroke="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M3 12h18M3 18h18M3 6h18" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextAlignCenter);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
